// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3h4DA","title":"styles_title__vB3A9"};